'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./DefaultLayout.scss');
var c = (0, _utils.mapAndJoinStyles)(styles);

exports.default = function (props) {
  return _react2.default.createElement(
    'div',
    { className: c('DefaultLayout') },
    props.children
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/layouts/DefaultLayout.jsx
// module id = 2965
// module chunks = 0